import { Form } from 'antd';
import { useEffect } from 'react';
import DefaultButton from '../../../components/buttons/defaultButton/DefaultButton';
import CustomerSelectInput from '../../../inputs/customerSelectInput/CustomerSelectInput';
import CustomerPhoneNumberInput from '../../../inputs/customerPhoneInput/CustomerPhoneNumberInput';
import CustomerVerificationInput from '../../../inputs/customerVerificationInput/CustomerVerificationInput';
import CustomerCheckInput from '../../../inputs/customerCheckInput/CustomerCheckInput';
import useTranslation from '../../../../hooks/translation/useTranslation';
import CustomerPasswordInput from '../../../inputs/customerPasswordInput/CustomerPasswordInput';
import CustomerTextInput from '../../../inputs/customerTextInput/CustomerTextInput';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';

function PhysicalRegistrationSecondStepForm({
  formValues, handleSubmit, form, errors, setErrors,
}) {
  const { setShowTermsModal } = useModal();
  const { trans, configInfo } = useTranslation();
  const phoneCode = Form.useWatch('country_phone_code', form);
  const countryPhoneCodes = formValues?.countries?.map((country) => ({
    label: country.country_phone_code,
    value: country.country_phone_code,
  }));

  useEffect(() => {
    if (!phoneCode) {
      const geoPhoneCode = countryPhoneCodes?.find((code) => code.value === '995');
      if (geoPhoneCode) {
        form.setFieldsValue({
          country_phone_code: geoPhoneCode.value,
        });
      }
    }
  }, [countryPhoneCodes, form]);

  const isGeorgian = configInfo?.countryCode === 'GE';

  useEffect(() => {
    if (!isGeorgian) {
      form.setFieldValue('verification', 1);
    }
  }, [isGeorgian]);
  return (
    <Form layout="vertical" form={form} onFinish={handleSubmit}>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerTextInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          className="flex-1"
          name="email"
          label={trans('email')}
          required
          errorMessage={errors?.email}
        />
        <CustomerPhoneNumberInput
          options={countryPhoneCodes}
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          noMask={phoneCode !== '995'}
          className="flex-1 white-background"
          name="phone_number"
          label={trans('phone_number')}
          selectName="country_phone_code"
          required
          errorMessage={errors?.country_phone_code || errors?.phone_number}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4">
        <CustomerPasswordInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }, {
            min: 8,
            message: trans('password_min_8_length'),
          }]}
          className="flex-1"
          name="password"
          label={trans('password')}
          required
          errorMessage={errors?.password && trans(errors.password)}
        />
        <CustomerPasswordInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject(trans('passwords_do_not_match'));
            },
          }),
          ]}
          className="flex-1"
          name="repeat_password"
          label={trans('repeat_password')}
          required
          errorMessage={errors?.repeat_password}
        />
      </div>
      <div className="flex flex-col lg:flex-row lg:gap-4">
        <CustomerSelectInput
          rules={[{
            required: true,
            message: trans('input_necessary'),
          }]}
          options={formValues?.verifications?.map((verification) => ({
            value: verification.value,
            label: trans(verification.label),
          }))}
          className={`flex-1 white-background ${!isGeorgian && '!hidden'}`}
          additionalClassName={!isGeorgian && '!hidden'}
          name="verification"
          label={trans('verification_method')}
          errorMessage={errors?.verification}
          search={false}
        />
        <CustomerVerificationInput
          className="flex-1"
          name="verified"
          label="ნომერი"
          errors={errors}
          setErrors={setErrors}
          form={form}
        />
      </div>
      <div className="flex flex-col lg:flex-row gap-4 lg:pt-[25px]">
        <div className="flex flex-col basis-1/2 relative">
          <CustomerCheckInput
            className="lg:absolute -top-5"
            label={(
              <button
                type="button"
                className="text-primary border-0 bg-transparent cursor-pointer text-[12px]"
                onClick={() => {
                  setShowTermsModal('terms-conditions');
                }}
              >
                {trans('agree_to_terms')}
              </button>
            )}
            name="agree_to_service_conditions"
            errorMessage={errors?.agree_to_service_conditions}
          />
          <CustomerCheckInput
            className="lg:absolute top-5"
            label={(
              <button
                type="button"
                className="text-primary border-0 bg-transparent cursor-pointer text-[12px]"
                onClick={() => {
                  setShowTermsModal('confidentiality-policy');
                }}
              >
                {trans('agree_to_confidentiality')}
              </button>
            )}
            name="agree_to_confidentiality"
            errorMessage={errors?.agree_to_confidentiality}
          />
        </div>
        <DefaultButton type="submit" className="basis-1/2 text-base leading-[22px]">
          {trans('finish_registration')}
        </DefaultButton>
      </div>
    </Form>
  );
}

export default PhysicalRegistrationSecondStepForm;
